import {jQuery as $, lodash as _} from 'lib/shim';

import {Context} from 'context';

import {waitForRepaint} from 'util/dom';



const NAME = 'organism-filterbox-locations',
	SELECTOR = '.'+NAME,
	FILTER_INPUTS_SELECTOR = ':input, select, :text, textarea',
	SUBMIT_MODE_ASYNC = 'async',
	SUBMIT_MODE_SYNC = 'sync',
	SUBMIT_MODES = [SUBMIT_MODE_ASYNC, SUBMIT_MODE_SYNC];



class OrganismFilterboxLocations {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$filterForm = this._$element.find('.filter-form').first();
			this._$filters = this._$filterForm.find('.filters .filter');
			this._$resetButton = this._$element.find('.buttons .reset');
			this._$submitButton = this._$element.find('.buttons .submit');

			this._originalSubmitCaption = this._$submitButton.text();

			this._submitResultCaptionSingularTemplate = $.isSet(this._$element.data('submit-result-caption-singular-template'))
				? this._$element.data('submit-result-caption-singular-template')
				: 'Show {count} result'
			;
			this._submitResultCaptionPluralTemplate = $.isSet(this._$element.data('submit-result-caption-plural-template'))
				? this._$element.data('submit-result-caption-plural-template')
				: 'Show {count} results'
			;
			this._submitNoResultCaptionTemplate = $.isSet(this._$element.data('submit-no-result-caption-template'))
				? this._$element.data('submit-no-result-caption-template')
				: 'No results to show'
			;

			// detect if form should submit via event with payload (async) or with browser default and reload (sync)
			this._submitMode = (
				$.isSet(this._$element.data('submit-mode'))
				&& _.includes(SUBMIT_MODES, this._$element.data('data-submit-mode'))
			) ? this._$element.data('data-submit-mode') : SUBMIT_MODE_ASYNC;

			// needs to be before prime()
			this._refreshFilterValues();
			this._prime();
			this._initPatternLabDemoBehaviour();
		}

		return $element;
	}



	_prime() {
		this._$filters.find(FILTER_INPUTS_SELECTOR).on('change', () => {
			this._refreshFilterValues();

			if( this._anyFiltersSet ){
				this._$resetButton.enable();
				this._$submitButton.enable();
			} else {
				this._$resetButton.disable();
				this._$submitButton.disable();
			}

			this._$element.triggerHandler('filterschanged.app', {filters : this._formData});
		});


		this._$resetButton
			.disable()
			.on('click', (e) => {
				e.preventDefault();

				if( this._anyFiltersSet ){
					this._$filters.find(FILTER_INPUTS_SELECTOR).each(function(){
						if( $(this).is('select') ){
							$(this).val($(this).find('option').first().attr('value'));

							if( $.isFunction($(this).selectric) ){
								$(this).selectric('refresh');
							}
						} else if( $(this).is(':checkbox, :radio') ){
							$(this).uncheck().trigger('init.stylableinput');
						} else if( $(this).is(':text, textarea') ){
							$(this).val('');
						} else {
							$(this).val('');
						}
					});

					this._refreshFilterValues();
					this._$resetButton.disable();
					// this._$submitButton.enable();
					this._$element.triggerHandler('filterschanged.app', {filters : this._formData, reset : true});
					this._$element.triggerHandler('submitted.app', {filters : this._formData});
					this._$submitButton.disable();
				}
			})
		;


		this._$submitButton.disable();


		this._$filterForm.on('submit', (e) => {
			switch( this._submitMode ){
				case SUBMIT_MODE_SYNC:
					// use browser default behaviour, but keep event from bubbling back to the element resulting in a loop
					e.stopPropagation();
				break;

				case SUBMIT_MODE_ASYNC:
				default:
					e.preventDefault();
					e.stopPropagation();

					this._$submitButton.disable();

					this._$element.triggerHandler('submitted.app', {filters : this._formData});
				break;
			}
		});


		this._$element
			// if a submit is triggered manually by an event on the organism, just submit the form and let its handler deal with it
			.on('submit.app', () => {
				this._$filterForm.submit();
			})

			// request a "serialized" event containing the current formdata as payload
			.on('serialize.app', () => {
				this._refreshFilterValues();
				this._$element.triggerHandler('serialized.app', {filters : this._formData});
			})
			.on('updatefilterdata.app', (e, data) => {
				if( $.isSet(data.count) ){
					let count = parseInt(data.count, 10);

					if( count > 0 ){
						this._$submitButton
							.text(
								$.strFormat((count === 1)
								? this._submitResultCaptionSingularTemplate
								: this._submitResultCaptionPluralTemplate, {count : count})
							)
						;

						if( !data.keepSubmitState ){
							this._$submitButton.enable();
						}
					} else {
						this._$submitButton.text(this._submitNoResultCaptionTemplate);

						if( !data.keepSubmitState ){
							this._$submitButton.disable();
						}
					}
				} else {
					this._$submitButton.text(this._originalSubmitCaption);

					if( !data.keepSubmitState ){
						this._$submitButton.disable();
					}
				}

				if( $.isPlainObject(data.filters) ){
					if( data.mode === 'from-scratch' ){
						this._$filters.find('[name]').each(function(){
							let name = $(this).attr('name');

							if( !$.isSet(data.filters[name]) ){
								data.filters[name] = '';
							}
						});
					}

					_.each(data.filters, (value, filterName) => {
						this._$filterForm.find('[name="'+filterName+'"]').each(function(){
							if( $(this).is('select') ){
								let options = $.isArray(value) ? value : [value],
									currentVal = $(this).val();

								$(this).children('option[value!=""]').remove();
								_.each(options, (option) => {
									if( $.isSet(option.value, option.text) ){
										$(this).append($(`<option value="${option.value}">${option.text}</option>`));
									}
								});

								waitForRepaint(() => {
									$(this).val(currentVal);

									if( $.isFunction($(this).selectric) ){
										$(this).selectric('refresh');

										if( $.isEmpty($(this).val()) ){
											let $label = $(this).parent('.selectric-hide-select').siblings('.selectric').find('.label');
											if( !$.exists($label.children('.default')) ){
												$label.html(`<span class="default">${$label.text()}</span>`);
											}
										}
									}
								});
							} /*if( $(this).is(':checkbox, :radio') ){
								if( !!value ){
									$(this).check().trigger('change');
								} else {
									$(this).uncheck().trigger('change');
								} /*
							} if( $(this).is(':text, textarea') ){
								$(this).val(''+value);
							} else {
								$(this).val(''+value);
							}*/
						});
					});

					waitForRepaint(() => {
						this._refreshFilterValues();
						if( !this._anyFiltersSet ){
							this._$resetButton.disable();
						}
					});
				}
			})
		;


		_.defer(() => {
			this._$element.triggerHandler('initialized.app', {filters : this._formData});
		});
	}



	_refreshFilterValues(){
		this._formData = this._$filterForm.formDataToObject();
		this._cleanFilterValues();
		this._anyFiltersSet = !!_.size(this._formData);
	}



	_cleanFilterValues(){
		let formData = {};

		_.each(this._formData, (value, key) => {
			if( _.trim(value) !== '' ){
				formData[key] = value;
			}
		});

		this._formData = formData;
	}



	_initPatternLabDemoBehaviour(){
		if(
			(
				Context.get('runningInPatternLabList')
				|| Context.get('runningInPatternLabDetails')
			) && (this._$element.parent().closest('[class^="organism-"]').length === 0)
		){
			this._$element
				.on('filterschanged.app', (e, data) => {
					if( !data.reset ){
						let emptyFilters = (_.random(0, 5) === 0),
							values = [_.random(10, 99), _.random(10, 99), _.random(10, 99)];

						this._$element.triggerHandler('updatefilterdata.app', {
							count : !emptyFilters ? _.random(1, 999) : 0,
							mode : !emptyFilters ? 'additive' : 'from-scratch',
							filters : !emptyFilters
								? {
									[`filter${_.random(1, 4)}`] : [
										{
											value : values[0],
											text : `Filter ${values[0]}`
										},
										{
											value : values[1],
											text : `Filter ${values[1]} Filter ${values[1]} Filter ${values[1]}`
										},
										{
											value : values[2],
											text : `Filter ${values[2]} Filter ${values[2]}`
										}
									]
								}
								: {}
						});
					}
				})
				.on('initialized.app', (e, data) => {
					$.log('OrganismFilterboxLocations -> initialized.app', data.filters);
				})
				.on('submitted.app', (e, data) => {
					$.log('OrganismFilterboxLocations -> submitted.app', data.filters);
				})
			;
		}
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new OrganismFilterboxLocations(app, $this));
	});

	return $elements;
}
